import { FC } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router';

import { AUTH_ROUTES } from '@navigation/types';
import Modal from '@components/modal';
import { PremierText } from '@components/text';
import SkewedButton from '@components/buttons/SkewedButton';
import { MOBILE_SKEW_ANGLE, SKEW_ANGLE } from '@utils/constants';

const Wrapper = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

const TextContainer = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transform: skewX(${SKEW_ANGLE}deg);

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    transform: skewX(${MOBILE_SKEW_ANGLE}deg);
  }
`;

const ModalFooter = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 16px;
  margin-top: 16px;
  transform: skewX(${SKEW_ANGLE}deg);

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    transform: skewX(${MOBILE_SKEW_ANGLE}deg);
  }
`;

const Button = styled(SkewedButton)`
  flex: 1;
  max-width: 300px;
`;

type Props = {
  isShown: boolean;
  onClose: () => void;
};

const UnauthorizedUserModal: FC<Props> = ({ isShown, onClose }) => {
  const navigate = useNavigate();

  const onLogin = () => {
    onClose();
    navigate(AUTH_ROUTES.LOGIN);
  };

  return (
    <Modal
      isShown={isShown}
      title='Authorization Required'
      onClose={onClose}
      isActionable={false}
    >
      <Wrapper>
        <TextContainer>
          <PremierText>
            Please sign in to your account or register to gain access
          </PremierText>
        </TextContainer>

        <ModalFooter>
          <Button onClick={onLogin}>Log In</Button>
        </ModalFooter>
      </Wrapper>
    </Modal>
  );
};

export default UnauthorizedUserModal;
